<!--  -->
<template>
  <div>
    <el-form
      :label-position="labelPosition"
      label-width="100px"
      :model="formLabelAlign"
    >
      <el-form-item label="小程序名称">
        <el-input
          v-model="formLabelAlign.name"
          style="width: 500px;"
        ></el-input>
      </el-form-item>
      <el-form-item label="小程序编号">
        <el-input
          :disabled="type === 2"
          v-model="formLabelAlign.applet_no"
          style="width: 500px;"
        ></el-input>
      </el-form-item>
      <el-form-item label="目标分类">
        <el-select
          v-model="formLabelAlign.category_id"
          placeholder="请选择"
        >
          <el-option
            v-for="item in options"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          @click="sumbit"
        >确定</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { videoSettingstore, videoSettingupdate } from '@/api/sourceminiprogram.js'
import { videoCategorylist } from '@/api/sourceminiprogram.js'
export default {
  components: {},
  data() {
    return {
      labelPosition: 'right',
      formLabelAlign: {
        name: '',
        applet_no: '',
        category_id: null
      },
      type: null,
      options: []
    }
  },
  created() {},
  mounted() {},
  methods: {
    sumbit() {
      if (this.formLabelAlign.name === '') {
        this.$message.error('请输入小程序名称')
        return
      }
      if (this.formLabelAlign.applet_no === '') {
        this.$message.error('请输入小程序编号')
        return
      }
      if (this.formLabelAlign.category_id === null) {
        this.$message.error('请选择目标分类')
        return
      }
      if (this.type === 1) {
        videoSettingstore(this.formLabelAlign).then(res => {
          this.$message({
            message: '新增成功',
            type: 'success'
          })
          this.$emit('updata')
        })
      } else {
        videoSettingupdate(this.formLabelAlign).then(res => {
          this.$message({
            message: '修改成功',
            type: 'success'
          })
          this.$emit('updata')
        })
      }
    },
    send(type, item) {
      this.type = type
      this.getDatas()
      if (this.type === 2) {
        this.formLabelAlign.name = item.name
        this.formLabelAlign.applet_no = item.applet_no
        this.formLabelAlign.category_id = item.category_id
      }
    },
    async getDatas() {
      const data = await videoCategorylist({ page: 1, page_size: 100 })
      console.log('data', data)
      this.options = data.data.list
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
</style>
